module.exports = __webpack_public_path__ + "img/GMS-logo-color.90631019.png";